/* Dusk & Relic — reviews interactivity (no dependencies).
   • load-more collapse per list        • sort (recent / high / low / with photos)
   • rating-distribution filter          • photo / video lightbox (keyboard + swipe-safe)
   • external submission form success (posts to a hidden iframe)
   Star picker is pure CSS; nothing here is required for the form to submit. */
(function () {
  if (window.__dnrReviews) return;
  window.__dnrReviews = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- review list: filter + sort + load-more ---------------- */
  function setupList(list) {
    var perPage = parseInt(list.getAttribute('data-per-page'), 10) || 6;
    var cards = Array.prototype.slice.call(list.querySelectorAll('.dnr2-rvw'));
    if (!cards.length) return;

    var section = list.closest('.dnr2-reviews') || document;
    var moreWrap = section.querySelector('[data-dnr-reviews-more-wrap]');
    var moreBtn = section.querySelector('[data-dnr-reviews-more]');
    var sortSel = section.querySelector('[data-dnr-review-sort]');
    var fnote = section.querySelector('[data-dnr-filternote]');
    var distBtns = Array.prototype.slice.call(section.querySelectorAll('[data-dnr-filter-star]'));

    var state = { sort: 'recent', filter: null, visible: perPage };

    function num(el, attr) { return parseFloat(el.getAttribute(attr)) || 0; }

    var comparators = {
      recent: function (a, b) { return num(b, 'data-date') - num(a, 'data-date'); },
      high: function (a, b) { return num(b, 'data-rating') - num(a, 'data-rating') || num(b, 'data-date') - num(a, 'data-date'); },
      low: function (a, b) { return num(a, 'data-rating') - num(b, 'data-rating') || num(b, 'data-date') - num(a, 'data-date'); },
      media: function (a, b) {
        var am = a.getAttribute('data-has-media') ? 1 : 0, bm = b.getAttribute('data-has-media') ? 1 : 0;
        return bm - am || num(b, 'data-date') - num(a, 'data-date');
      }
    };

    function apply() {
      var eligible = cards.filter(function (c) {
        return !state.filter || c.getAttribute('data-rating') === state.filter;
      });
      eligible.sort(comparators[state.sort] || comparators.recent);

      // move eligible cards to the front in sorted order, hide the rest
      eligible.forEach(function (c, i) {
        list.appendChild(c);
        var clamped = i >= state.visible;
        c.classList.toggle('is-clamped', clamped);
        c.hidden = false;
        if (!clamped) c.classList.add('in'); // reveal (observer can't see display:none cards)
      });
      cards.forEach(function (c) {
        if (eligible.indexOf(c) === -1) { c.hidden = true; list.appendChild(c); }
      });

      if (moreWrap) moreWrap.hidden = eligible.length <= state.visible;
      if (fnote) {
        if (state.filter) {
          fnote.hidden = false;
          fnote.innerHTML = 'Showing ' + state.filter + '-star reviews — ';
          var clr = document.createElement('button');
          clr.type = 'button'; clr.setAttribute('data-dnr-filter-clear', ''); clr.textContent = 'show all';
          fnote.appendChild(clr);
        } else { fnote.hidden = true; fnote.textContent = ''; }
      }
      distBtns.forEach(function (b) {
        b.classList.toggle('is-active', state.filter === b.getAttribute('data-dnr-filter-star'));
      });
    }

    if (moreBtn) moreBtn.addEventListener('click', function () { state.visible += perPage; apply(); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.visible = perPage; apply(); });
    distBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.getAttribute('data-dnr-filter-star');
        state.filter = state.filter === s ? null : s;
        state.visible = perPage; apply();
      });
    });
    if (fnote) fnote.addEventListener('click', function (e) {
      if (e.target.closest('[data-dnr-filter-clear]')) { state.filter = null; state.visible = perPage; apply(); }
    });

    apply();
  }

  /* ------------------------------ lightbox ------------------------------- */
  function setupLightbox() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-dnr-lightbox]'));
    if (!thumbs.length) return;
    var items = thumbs.map(function (t) { return { type: t.getAttribute('data-type'), src: t.getAttribute('data-src') }; });
    var box, stage, idx = 0, lastFocus = null;

    function build() {
      box = document.createElement('div');
      box.className = 'dnr2-lb'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.hidden = true;
      box.innerHTML =
        '<button class="dnr2-lb__x" data-lb-close aria-label="Close">&#10005;</button>' +
        '<button class="dnr2-lb__nav dnr2-lb__nav--prev" data-lb-prev aria-label="Previous">&#8249;</button>' +
        '<figure class="dnr2-lb__stage" data-lb-stage></figure>' +
        '<button class="dnr2-lb__nav dnr2-lb__nav--next" data-lb-next aria-label="Next">&#8250;</button>';
      document.body.appendChild(box);
      stage = box.querySelector('[data-lb-stage]');
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('[data-lb-close]')) close();
        else if (e.target.closest('[data-lb-prev]')) go(-1);
        else if (e.target.closest('[data-lb-next]')) go(1);
      });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
    }

    function render() {
      var it = items[idx];
      stage.innerHTML = it.type === 'video'
        ? '<video src="' + it.src + '" controls autoplay playsinline></video>'
        : '<img src="' + it.src + '" alt="Review media">';
      var multi = items.length > 1;
      box.querySelector('[data-lb-prev]').hidden = !multi;
      box.querySelector('[data-lb-next]').hidden = !multi;
    }
    function go(d) { idx = (idx + d + items.length) % items.length; render(); }
    function open(i) {
      if (!box) build();
      idx = i; lastFocus = document.activeElement; render();
      box.hidden = false; document.documentElement.style.overflow = 'hidden';
      box.querySelector('[data-lb-close]').focus();
    }
    function close() {
      if (!box) return;
      var v = stage.querySelector('video'); if (v) v.pause();
      box.hidden = true; document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
  }

  /* ------------------- external form (Google Form) success --------------- */
  function setupExternalForm() {
    var form = document.querySelector('[data-dnr-rvw-external]');
    if (!form) return;
    var ok = document.querySelector('[data-dnr-rvw-ok]');
    form.addEventListener('submit', function () {
      // let the native POST reach the hidden iframe, then confirm + reset
      setTimeout(function () {
        if (ok) { ok.hidden = false; try { ok.focus(); } catch (e) {} }
        form.reset();
        form.style.display = 'none';
      }, 400);
    });
  }

  /* ------------- collapsible review form (click to reveal) --------------- */
  function setupFormToggle() {
    var form = document.getElementById('dnr-review-form');
    if (!form || form.className.indexOf('dnr2-rvwform--collapsible') === -1) return;

    function openForm(focusIt) {
      form.classList.add('is-open');
      if (focusIt) {
        var first = form.querySelector('input:not([type=hidden]):not(.dnr2-hp), textarea, select');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
      }
    }

    // any "Write a review" / "Be the first to review" trigger reveals the form
    document.addEventListener('click', function (e) {
      var t = e.target.closest('a[href="#dnr-review-form"], [data-dnr-rvwform-open]');
      if (!t) return;
      openForm(false);
      setTimeout(function () { openForm(true); }, 320); // focus after the native anchor scroll
    });

    // keep it open after a submit so success / error is visible, or if deep-linked
    if (form.querySelector('.dnr2-rvwform__ok:not([hidden]), .dnr2-rvwform__err')) openForm(false);
    if (location.hash === '#dnr-review-form') openForm(false);
  }

  ready(function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-dnr-reviews-list]')).forEach(setupList);
    setupLightbox();
    setupExternalForm();
    setupFormToggle();
  });
})();
